import { useState } from 'react';

import { ChangeStore } from 'components/header/menu-system/change-store/ChangeStore';
import { MenuSystemDesktop } from 'components/header/menu-system/desktop/MenuSystemDesktop';
import { MenuSystemLogoutModal } from 'components/header/menu-system/MenuSystemLogoutModal';
import { MenuSystemMobile } from 'components/header/menu-system/mobile/MenuSystemMobile';
import { useBreakpoints } from 'hooks/useBreakpoints';

export function MenuSystem() {
    const { isUpMd } = useBreakpoints();
    const [openChangeStoreModal, setOpenChangeStoreModal] = useState(false);
    const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false);

    return (
        <>
            <ChangeStore open={openChangeStoreModal} setOpen={setOpenChangeStoreModal} />

            <MenuSystemLogoutModal open={openLogoutConfirm} setOpen={setOpenLogoutConfirm} />

            {isUpMd && <MenuSystemDesktop setOpenChangeStoreModal={setOpenChangeStoreModal} setOpenLogoutConfirm={setOpenLogoutConfirm} />}

            {!isUpMd && <MenuSystemMobile setOpenChangeStoreModal={setOpenChangeStoreModal} setOpenLogoutConfirm={setOpenLogoutConfirm} />}
        </>
    );
}
